import { render, staticRenderFns } from "./CreateClientModal.vue?vue&type=template&id=600a654c&lang=pug&"
import script from "./CreateClientModal.vue?vue&type=script&lang=js&"
export * from "./CreateClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports